

// import React, { useState, useEffect } from "react";
// import {
//   AppBar,
//   Toolbar,
//   Button,
//   Box,
//   ToggleButton,
//   ToggleButtonGroup,
//   Typography,
//   styled,
//   Avatar,
//   IconButton,
//   Drawer,
//   List,
//   ListItem,
//   ListItemButton,
//   ListItemText,
//   Divider,
//   useMediaQuery,
//   useTheme,
// } from "@mui/material";
// import MenuIcon from "@mui/icons-material/Menu";
// import CloseIcon from "@mui/icons-material/Close";
// import { useNavigate, useLocation } from "react-router-dom";
// import ayujalogo from "../Logos/Ayuja_Logo.jpg";
// import { fetchUserFromRedis } from "../../Components/HomePage/AuthonticationScreens/Register";
// import CustomDialog from "../../CustomDialog";
// import { apiRequest } from "../../fetchSetup";

// const StyledAvatar = styled("div")`
//   font-family: "Roboto";
//   letter-spacing: 0.1px;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   width: 40px;
//   height: 40px;
//   background-color: #006d77;
//   color: white;
//   font-size: 20px;
//   font-weight: bold;
//   border-radius: 50%;
// `;

// // Public nav links (not logged in)
// const publicNavLinks = [
//   { label: "Home", path: "/" },
//   { label: "Services", path: "/serviceweprovide" },
//   { label: "About Us", path: "/aboutus" },
//   { label: "Packages", path: "/packages" },
//   { label: "Contact Us", path: "/contactus" },
// ];

// // Logged-in nav links (always shown)
// const baseUserLinks = [
//   { label: "Home", path: "/services" },
//   { label: "Profile", path: "/profile-details" },
// ];

// // Resident-only links
// const residentLinks = [
//   { label: "Medicine Orders", path: "/my-orders" },
//   { label: "Diagnostic Orders", path: "/my-bookings" },
//   { label: "Booked Packages", path: "/my-packagebookings" },
//   { label: "Cancellations", path: "/cancelled-bookings" },
//   { label: "My Complaints", path: "/my-complaints" },
//   { label: "Subscription Plans", path: "/subscription-management" },
//   { label: "FeedBack", path: "/my-Feedback" },
// ];

// function Header({ username }) {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("md")); // < 900px
//   const isTablet = useMediaQuery("(max-width:1300px)");
//   const isSmallDesktop = useMediaQuery("(max-width:1380px)");
//   const isMediumDesktop = useMediaQuery("(max-width:1450px)");

//   const [selected, setSelected] = useState("");
//   const [user, setUser] = useState(null);
//   const [drawerOpen, setDrawerOpen] = useState(false);
//   const [dialogOpen, setDialogOpen] = useState(false);

//   const logoutapi = process.env.REACT_APP_LOGOUT_API;

//   const width = window.innerWidth;

//   let navFontSize = 16;
//   let navPx = 2;

//   if (width <= 1100) {
//     navFontSize = 11;
//     navPx = 0.5;
//   } else if (width <= 1300) {
//     navFontSize = 12;
//     navPx = 0.8;
//   } else if (width <= 1450) {
//     navFontSize = 13;
//     navPx = 1.2;
//   }

//   useEffect(() => {
//     const fetchUser = async () => {
//       const userId = sessionStorage.getItem("userId");
//       const token = sessionStorage.getItem("token");
//       if (!userId || !token) {
//         setUser(null);
//         return;
//       }
//       try {
//         const userData = await fetchUserFromRedis(userId, token);
//         setUser(userData || null);
//       } catch (err) {
//         console.error("Error fetching user from Redis:", err);
//         setUser(null);
//       }
//     };
//     fetchUser();
//   }, [location,username]);

//   const handleChange = (event, newValue) => {
//     if (newValue !== null) setSelected(newValue);
//   };

//   const confirmLogout = () => {
//     setDialogOpen(true);
//     setDrawerOpen(false);
//   };

//   const handleLogout = async () => {
//     try {
//       const userId = sessionStorage.getItem("userId");
//       await apiRequest(`${logoutapi}/${userId}`, { method: "POST" });
//       sessionStorage.clear();
//       setUser(null);
//       navigate("/Login");
//     } catch (error) {
//       console.error("Logout failed:", error);
//       sessionStorage.clear();
//       navigate("/Login");
//     }
//   };

//   const isActive = (path) => location.pathname === path;

//   // All nav links for the current user role
//   const userNavLinks =
//     user?.role === "resident"
//       ? [...baseUserLinks, ...residentLinks]
//       : baseUserLinks;

//   // ─── Drawer (mobile/tablet) ────────────────────────────────────────────────
//   const renderDrawer = () => (
//     <Drawer
//       anchor="right"
//       open={drawerOpen}
//       onClose={() => setDrawerOpen(false)}
//       PaperProps={{ sx: { width: 260, backgroundColor: "#f9fafb" } }}
//     >
//       <Box sx={{ display: "flex", justifyContent: "flex-end", p: 1 }}>
//         <IconButton onClick={() => setDrawerOpen(false)}>
//           <CloseIcon />
//         </IconButton>
//       </Box>

//       {/* User info at top of drawer */}
//       {user && (
//         <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, px: 2, pb: 2 }}>
//           <Avatar
//             alt={user.name}
//             src={user.avatarUrl || ""}
//             sx={{ width: 40, height: 40, bgcolor: "#007a85", fontWeight: "bold" }}
//           >
//             {!user.avatarUrl && user.name ? user.name.charAt(0).toUpperCase() : ""}
//           </Avatar>
//           <Typography variant="body1" sx={{ fontWeight: "bold", color: "#153f4b" }}>
//             {user.name}
//           </Typography>
//         </Box>
//       )}

//       <Divider />

//       <List>
//         {/* Public links */}
//         {!user &&
//           publicNavLinks.map((link) => (
//             <ListItem key={link.path} disablePadding>
//               <ListItemButton
//                 onClick={() => {
//                   navigate(link.path);
//                   setDrawerOpen(false);
//                 }}
//                 selected={isActive(link.path)}
//                 sx={{
//                   "&.Mui-selected": { backgroundColor: "#e0f2f1", color: "teal" },
//                 }}
//               >
//                 <ListItemText
//                   primary={link.label}
//                   primaryTypographyProps={{ fontWeight: isActive(link.path) ? "bold" : "normal" }}
//                 />
//               </ListItemButton>
//             </ListItem>
//           ))}

//         {/* User links */}
//         {user &&
//           userNavLinks.map((link) => (
//             <ListItem key={link.path} disablePadding>
//               <ListItemButton
//                 onClick={() => {
//                   navigate(link.path);
//                   setDrawerOpen(false);
//                 }}
//                 selected={isActive(link.path)}
//                 sx={{
//                   "&.Mui-selected": { backgroundColor: "#e0f2f1", color: "teal" },
//                 }}
//               >
//                 <ListItemText
//                   primary={link.label}
//                   primaryTypographyProps={{ fontWeight: "bold" }}
//                 />
//               </ListItemButton>
//             </ListItem>
//           ))}

//         {/* Logout */}
//         {/* {user && (
//           <>
//             <Divider sx={{ my: 1 }} />
//             <ListItem disablePadding>
//               <ListItemButton onClick={confirmLogout}>
//                 <ListItemText
//                   primary="Logout"
//                   primaryTypographyProps={{ fontWeight: "bold", color: "#d32f2f" }}
//                 />
//               </ListItemButton>
//             </ListItem>
//           </>
//         )} */}

//         {/* Login / Register for guests */}
//         {!user && (
//           <>
//             <Divider sx={{ my: 1 }} />
//             <ListItem disablePadding>
//               <ListItemButton
//                 onClick={() => {
//                   navigate("/Login");
//                   setDrawerOpen(false);
//                 }}
//               >
//                 <ListItemText primary="Login" primaryTypographyProps={{ fontWeight: "bold" }} />
//               </ListItemButton>
//             </ListItem>
//             <ListItem disablePadding>
//               <ListItemButton
//                 onClick={() => {
//                   navigate("/Register");
//                   setDrawerOpen(false);
//                 }}
//               >
//                 <ListItemText primary="Register" primaryTypographyProps={{ fontWeight: "bold" }} />
//               </ListItemButton>
//             </ListItem>
//           </>
//         )}
//       </List>
//     </Drawer>
//   );

//   // ─── Desktop / Tablet nav button style ────────────────────────────────────
//   const navBtnSx = (path) => ({
//     textTransform: "none",
//     color: isActive(path) ? "teal" : "#121212",
//     fontWeight: isActive(path) ? "bold" : "normal",
//     borderBottom: isActive(path) ? "2px solid teal" : "none",
//     borderRadius: 0,
//     fontSize: navFontSize,
//     whiteSpace: "nowrap",
//     minWidth: "auto",
//     px: navPx,
//   });

//   const userNavBtnSx = {
//     textTransform: "none",
//     color: "black",
//     fontWeight: "bold",
//     fontSize: navFontSize, 
//     whiteSpace: "wrap",
//     minWidth: "auto",
//     px: navPx,
//   };

//   // ─── Render ────────────────────────────────────────────────────────────────
//   return (
//     <AppBar position="fixed" sx={{ backgroundColor: "#fff", color: "#153f4b", boxShadow: "0 2px 8px rgba(0,0,0,0.08)" }}>
//       <Toolbar sx={{ flexDirection: "column", padding: "0!important" }}>

//         {/* ── NOT LOGGED IN ───────────────────────────────────────────────── */}
//         {!user && (
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               width: "100%",
//               px: { xs: 2, sm: 3, md: 4, lg: 6 },
//               py: 1,
//             }}
//           >
//             {/* Logo */}
//             <Box display="flex" alignItems="center" sx={{ flexShrink: 0 }}>
//               <img
//                 src={ayujalogo}
//                 alt="Ayuja Logo"
//                 style={{ width: isMobile ? 110 : 150, height: isMobile ? 36 : 48, marginRight: 10 }}
//               />
//             </Box>

//             {/* Desktop / Tablet: center nav */}
//             {!isMobile && (
//               <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: isTablet ? 1 : 3, flexGrow: 1 }}>
//                 {publicNavLinks.map((link) => (
//                   <Button key={link.path} onClick={() => navigate(link.path)} sx={navBtnSx(link.path)}>
//                     {link.label}
//                   </Button>
//                 ))}
//               </Box>
//             )}

//             {/* Desktop: Login/Register toggle */}
//             {!isMobile && (
//               <Box sx={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
//                 <ToggleButtonGroup
//                   value={selected}
//                   exclusive
//                   onChange={handleChange}
//                   sx={{
//                     width: isTablet ? "130px" : "150px",
//                     height: "35px",
//                     borderRadius: "30px",
//                     overflow: "hidden",
//                     border: "1px solid teal",
//                   }}
//                 >
//                   <ToggleButton
//                     value="login"
//                     onClick={() => navigate("/Login")}
//                     sx={{
//                       textTransform: "none",
//                       fontWeight: "bold",
//                       fontSize: isTablet ? "12px" : "14px",
//                       px: isTablet ? 1.5 : 2,
//                       "&.Mui-selected": {
//                         background: "linear-gradient(to right, seagreen, #22577A)",
//                         color: "white",
//                       },
//                     }}
//                   >
//                     Login
//                   </ToggleButton>
//                   <ToggleButton
//                     value="register"
//                     onClick={() => navigate("/Register")}
//                     sx={{
//                       textTransform: "none",
//                       fontWeight: "bold",
//                       fontSize: isTablet ? "12px" : "14px",
//                       px: isTablet ? 1 : 1,
//                       "&.Mui-selected": {
//                         background: "linear-gradient(to right, seagreen, #22577A)",
//                         color: "white",
//                       },
//                     }}
//                   >
//                     Register
//                   </ToggleButton>
//                 </ToggleButtonGroup>
//               </Box>
//             )}

//             {/* Mobile: Hamburger */}
//             {isMobile && (
//               <IconButton onClick={() => setDrawerOpen(true)} sx={{ color: "#153f4b" }}>
//                 <MenuIcon />
//               </IconButton>
//             )}
//           </Box>
//         )}

//         {/* ── LOGGED IN ───────────────────────────────────────────────────── */}
//         {user && (
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               width: "100%",
//               backgroundColor: "white",
//               px: { xs: 2, sm: 3, md: 4, lg: 6 },
//               py: 1,
//               gap: 1,
//             }}
//           >
//             {/* Logo */}
//             <Box display="flex" alignItems="center" sx={{ flexShrink: 0 }}>
//               <img
//                 src={ayujalogo}
//                 alt="Ayuja Logo"
//                 style={{ width: isMobile ? 110 : 150, height: isMobile ? 36 : 48 }}
//               />
//             </Box>

//             {/* Desktop/Tablet: nav buttons */}
//             {!isMobile && (
//               <Box sx={{ display: "flex", alignItems: "center", gap: isTablet ? 0.5 : 2, flexGrow: 1, justifyContent: "center", overflow: "hidden" }}>
//                 {userNavLinks.map((link) => (
//                   <Button key={link.path} onClick={() => navigate(link.path)} sx={userNavBtnSx}>
//                     {link.label}
//                   </Button>
//                 ))}
//                 {/* <Button onClick={confirmLogout} sx={{ ...userNavBtnSx, color: "#d32f2f" }}>
//                   Logout
//                 </Button> */}
//               </Box>
//             )}

//             {/* Right: User avatar + name (desktop) or just avatar (mobile) */}
//             <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexShrink: 0 }}>
//               {!isMobile && (
//                 <Typography variant="body1" sx={{ color: "black", fontWeight: "bold", fontSize: isTablet ? "13px" : "15px" }}>
//                   {user.name}
//                 </Typography>
//               )}
//               <Avatar
//                 alt={user.name}
//                 src={user.avatarUrl || ""}
//                 sx={{ width: 38, height: 38, bgcolor: "#007a85", fontWeight: "bold", fontSize: "16px" }}
//               >
//                 {!user.avatarUrl && user.name ? user.name.charAt(0).toUpperCase() : ""}
//               </Avatar>

//               {/* Mobile: Hamburger */}
//               {isMobile && (
//                 <IconButton onClick={() => setDrawerOpen(true)} sx={{ color: "#153f4b" }}>
//                   <MenuIcon />
//                 </IconButton>
//               )}
//             </Box>
//           </Box>
//         )}
//       </Toolbar>

//       {/* Mobile/Tablet Drawer */}
//       {renderDrawer()}

//       <CustomDialog
//         open={dialogOpen}
//         title="Confirm Logout"
//         message="Are you sure you want to log out?"
//         onClose={() => setDialogOpen(false)}
//         buttonText="Yes"
//         secondaryButtonText="Cancel"
//         onPrimaryAction={() => {
//           setDialogOpen(false);
//           handleLogout();
//         }}
//         onSecondaryAction={() => setDialogOpen(false)}
//         type="warning"
//       />
//     </AppBar>
//   );
// }

// export default Header;









































import React, { useState, useEffect, useRef } from "react";
import {
  AppBar, Toolbar, Button, Box, ToggleButton, ToggleButtonGroup,
  Typography, styled, Avatar, IconButton, Drawer, List, ListItem,
  ListItemButton, ListItemText, Divider, useMediaQuery, useTheme,
  Popper, Paper, Grow, ClickAwayListener, MenuList, MenuItem,
  Collapse,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import MedicationOutlinedIcon from "@mui/icons-material/MedicationOutlined";
import BiotechOutlinedIcon from "@mui/icons-material/BiotechOutlined";
import CardMembershipOutlinedIcon from "@mui/icons-material/CardMembershipOutlined";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import { useNavigate, useLocation } from "react-router-dom";
import ayujalogo from "../Logos/Ayuja_Logo.jpg";
import { fetchUserFromRedis } from "../../Components/HomePage/AuthonticationScreens/Register";
import CustomDialog from "../../CustomDialog";
import { apiRequest } from "../../fetchSetup";

// ─── ORDER SUBMENU OPTIONS ─────────────────────────────────────────────────────
const orderSubLinks = [
  {
    label: "Medicine Orders",
    path: "/my-orders",
    icon: <MedicationOutlinedIcon sx={{ fontSize: 18 }} />,
    desc: "Track your medicine deliveries",
    color: "#006D77",
    bg: "#E0F7FA",
  },
  {
    label: "Diagnostic Orders",
    path: "/my-bookings",
    icon: <BiotechOutlinedIcon sx={{ fontSize: 18 }} />,
    desc: "View lab test results & status",
    color: "#7B1FA2",
    bg: "#F3E5F5",
  },
  {
    label: "Booked Packages",
    path: "/my-packagebookings",
    icon: <CardMembershipOutlinedIcon sx={{ fontSize: 18 }} />,
    desc: "Manage your health packages",
    color: "#E65100",
    bg: "#FFF3E0",
  },
];

// ─── SUPPORT SUBMENU OPTIONS ──────────────────────────────────────────────────
const supportSubLinks = [
  {
    label: "Complaints",
    path: "/my-complaints",
    icon: <ReportProblemOutlinedIcon sx={{ fontSize: 18 }} />,
    desc: "View & track your complaints",
    color: "#C62828",
    bg: "#FFEBEE",
  },
  {
    label: "Feedback",
    path: "/my-Feedback",
    icon: <ChatBubbleOutlineIcon sx={{ fontSize: 18 }} />,
    desc: "View your submitted feedback",
    color: "#1565C0",
    bg: "#E3F2FD",
  },
];

// Public nav links
const publicNavLinks = [
  { label: "Home", path: "/" },
  { label: "Services", path: "/serviceweprovide" },
  { label: "About Us", path: "/aboutus" },
  { label: "Packages", path: "/packages" },
  { label: "Contact Us", path: "/contactus" },
];

// Base logged-in links (non-Orders)
const baseUserLinks = [
  { label: "Home", path: "/services" },
  { label: "Profile", path: "/profile-details" },
];

// Other resident links (not Orders group, not Cancellations/Complaints/etc.)
const extraResidentLinks = [
  { label: "Cancellations", path: "/cancelled-bookings" },
  { label: "Subscription Plans", path: "/subscription-management" },
];

// ─── ORDERS DROPDOWN (Desktop) ────────────────────────────────────────────────
function OrdersDropdown({ navFontSize, navPx, isActive, navigate, location }) {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  // Close when route changes
  useEffect(() => { setOpen(false); }, [location.pathname]);

  const isOrderActive = orderSubLinks.some((l) => isActive(l.path));

  return (
    <Box sx={{ position: "relative" }}>
      <Button
        ref={anchorRef}
        onClick={() => setOpen((v) => !v)}
        endIcon={
          open
            ? <KeyboardArrowUpIcon sx={{ fontSize: 1600, ml: -0.5 }} />
            : <KeyboardArrowDownIcon sx={{ fontSize: 16, ml: -0.5 }} />
        }
        sx={{
          textTransform: "none",
          color: isOrderActive || open ? "#006D77" : "#121212",
          fontWeight: isOrderActive || open ? "bold" : "bold",
          borderBottom: isOrderActive || open ? "2px solid #006D77" : "2px solid transparent",
          borderRadius: 0,
          fontSize: navFontSize,
          whiteSpace: "nowrap",
          minWidth: "auto",
          px: navPx,
          gap: 0.2,
          transition: "all 0.18s",
          "&:hover": { color: "#006D77", backgroundColor: "transparent", borderBottom: "2px solid #006D77" },
        }}
      >
        <ShoppingBagOutlinedIcon sx={{ fontSize: 17, mr: 0.4, mb: 0.2 }} />
        Orders
      </Button>

      <Popper
        open={open}
        anchorEl={anchorRef.current}
        placement="bottom-start"
        transition
        disablePortal={false}
        style={{ zIndex: 13001 }}
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps} timeout={180} style={{ transformOrigin: "top left" }}>
            <Paper
              elevation={0}
              sx={{
                mt: 1.5,
                borderRadius: "14px",
                border: "1px solid #E8F0F0",
                boxShadow: "0 8px 32px rgba(0,109,119,0.13), 0 2px 8px rgba(0,0,0,0.06)",
                overflow: "hidden",
                minWidth: 280,
              }}
            >
              {/* Header strip */}
              <Box sx={{ px: 2.5, py: 1.5, background: "linear-gradient(135deg, #006D77 0%, #00838F 100%)" }}>
                <Typography sx={{ color: "#fff", fontSize: 12, fontWeight: 700, letterSpacing: 0.5, textTransform: "uppercase" }}>
                  My Orders
                </Typography>
              </Box>

              <ClickAwayListener onClickAway={() => setOpen(false)}>
                <MenuList sx={{ p: 1 }}>
                  {orderSubLinks.map((item) => (
                    <MenuItem
                      key={item.path}
                      onClick={() => { navigate(item.path); setOpen(false); }}
                      selected={isActive(item.path)}
                      sx={{
                        borderRadius: "10px",
                        mb: 0.5,
                        px: 1.5,
                        py: 1.2,
                        gap: 1.5,
                        alignItems: "flex-start",
                        transition: "all 0.15s",
                        "&:hover": { backgroundColor: item.bg },
                        "&.Mui-selected": { backgroundColor: item.bg + "CC" },
                        "&:last-child": { mb: 0 },
                      }}
                    >
                      {/* Icon bubble */}
                      <Box sx={{
                        width: 36, height: 36, borderRadius: "10px",
                        backgroundColor: item.bg, color: item.color,
                        display: "flex", alignItems: "center", justifyContent: "center",
                        flexShrink: 0, mt: 0.2,
                        border: `1.5px solid ${item.color}22`,
                      }}>
                        {item.icon}
                      </Box>
                      <Box>
                        <Typography sx={{
                          fontSize: 13.5, fontWeight: isActive(item.path) ? 700 : 600,
                          color: isActive(item.path) ? item.color : "#1a1a1a",
                          lineHeight: 1.3,
                        }}>
                          {item.label}
                        </Typography>
                        <Typography sx={{ fontSize: 11, color: "#888", mt: 0.3, lineHeight: 1.3 }}>
                          {item.desc}
                        </Typography>
                      </Box>
                      {isActive(item.path) && (
                        <Box sx={{
                          ml: "auto", width: 6, height: 6, borderRadius: "50%",
                          backgroundColor: item.color, mt: 1.5, flexShrink: 0,
                        }} />
                      )}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </Box>
  );
}

// ─── SUPPORT DROPDOWN (Desktop) ───────────────────────────────────────────────
function SupportDropdown({ navFontSize, navPx, isActive, navigate, location }) {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  const isSupportActive = supportSubLinks.some((l) => isActive(l.path));

  return (
    <Box sx={{ position: "relative" }}>
      <Button
        ref={anchorRef}
        onClick={() => setOpen((v) => !v)}
        endIcon={
          open
            ? <KeyboardArrowUpIcon sx={{ fontSize: 16, ml: -0.5 }} />
            : <KeyboardArrowDownIcon sx={{ fontSize: 16, ml: -0.5 }} />
        }

        sx={{
          textTransform: "none",
          color: isSupportActive || open ? "#006D77" : "#121212",
          fontWeight: isSupportActive || open ? "bold" : "bold",
          borderBottom: isSupportActive || open ? "2px solid #006D77" : "2px solid transparent",
          borderRadius: 0,
          fontSize: navFontSize,
          whiteSpace: "nowrap",
          minWidth: "auto",
          px: navPx,
          gap: 0.2,
          transition: "all 0.18s",
          "&:hover": { color: "#006D77", backgroundColor: "transparent", borderBottom: "2px solid #006D77" },
        }}
      >
        <ForumOutlinedIcon sx={{ fontSize: 17, mr: 0.4, mb: 0.2 }} />
        My Requests
      </Button>

      <Popper
        open={open}
        anchorEl={anchorRef.current}
        placement="bottom-start"
        transition
        disablePortal={false}
        style={{ zIndex: 13001 }} 
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps} timeout={180} style={{ transformOrigin: "top left" }}>
            <Paper
              elevation={0}
              sx={{
                mt: 1.5,
                borderRadius: "14px",
                border: "1px solid #FDECEA",
                boxShadow: "0 8px 32px rgba(198,40,40,0.10), 0 2px 8px rgba(0,0,0,0.06)",
                overflow: "hidden",
                minWidth: 260,
              }}
            >
              {/* Header strip */}
              <Box sx={{ px: 2.5, py: 1.5, background: "linear-gradient(135deg, #006D77 0%, #00838F 100%)" }}>
                <Typography sx={{ color: "#fff", fontSize: 12, fontWeight: 700, letterSpacing: 0.5, textTransform: "uppercase" }}>
                My Requests
                </Typography>
              </Box>

              <ClickAwayListener onClickAway={() => setOpen(false)}>
                <MenuList sx={{ p: 1 }}>
                  {supportSubLinks.map((item) => (
                    <MenuItem
                      key={item.path}
                      onClick={() => { navigate(item.path); setOpen(false); }}
                      selected={isActive(item.path)}
                      sx={{
                        borderRadius: "10px",
                        mb: 0.5,
                        px: 1.5,
                        py: 1.2,
                        gap: 1.5,
                        alignItems: "flex-start",
                        transition: "all 0.15s",
                        "&:hover": { backgroundColor: item.bg },
                        "&.Mui-selected": { backgroundColor: item.bg + "CC" },
                        "&:last-child": { mb: 0 },
                      }}
                    >
                      {/* Icon bubble */}
                      <Box sx={{
                        width: 36, height: 36, borderRadius: "10px",
                        backgroundColor: item.bg, color: item.color,
                        display: "flex", alignItems: "center", justifyContent: "center",
                        flexShrink: 0, mt: 0.2,
                        border: `1.5px solid ${item.color}22`,
                      }}>
                        {item.icon}
                      </Box>
                      <Box>
                        <Typography sx={{
                          fontSize: 13.5, fontWeight: isActive(item.path) ? 700 : 600,
                          color: isActive(item.path) ? item.color : "#1a1a1a",
                          lineHeight: 1.3,
                        }}>
                          {item.label}
                        </Typography>
                        <Typography sx={{ fontSize: 11, color: "#888", mt: 0.3, lineHeight: 1.3 }}>
                          {item.desc}
                        </Typography>
                      </Box>
                      {isActive(item.path) && (
                        <Box sx={{
                          ml: "auto", width: 6, height: 6, borderRadius: "50%",
                          backgroundColor: item.color, mt: 1.5, flexShrink: 0,
                        }} />
                      )}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </Box>
  );
}

// ─── MAIN HEADER ──────────────────────────────────────────────────────────────
function Header({ username }) {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isTablet = useMediaQuery("(max-width:1300px)");

  const [selected, setSelected] = useState("");
  const [user, setUser] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [ordersDrawerOpen, setOrdersDrawerOpen] = useState(false);
  const [supportDrawerOpen, setSupportDrawerOpen] = useState(false);

  const logoutapi = process.env.REACT_APP_LOGOUT_API;
  const width = window.innerWidth;

  let navFontSize = 14;
  let navPx = 1.5;
  if (width <= 1100) { navFontSize = 11; navPx = 0.5; }
  else if (width <= 1300) { navFontSize = 12; navPx = 0.8; }
  else if (width <= 1450) { navFontSize = 13; navPx = 1.2; }

  useEffect(() => {
    const fetchUser = async () => {
      const userId = sessionStorage.getItem("userId");
      const token = sessionStorage.getItem("token");
      if (!userId || !token) { setUser(null); return; }
      try {
        const userData = await fetchUserFromRedis(userId, token);
        setUser(userData || null);
      } catch { setUser(null); }
    };
    fetchUser();
  }, [location, username]);

  const isActive = (path) => location.pathname === path;
  const isOrderActive = orderSubLinks.some((l) => isActive(l.path));

  const confirmLogout = () => { setDialogOpen(true); setDrawerOpen(false); };
  const isSupportActive = supportSubLinks.some((l) => isActive(l.path));
  const handleLogout = async () => {
    try {
      const userId = sessionStorage.getItem("userId");
      await apiRequest(`${logoutapi}/${userId}`, { method: "POST" });
    } catch {}
    sessionStorage.clear();
    setUser(null);
    navigate("/Login");
  };

  const navBtnSx = (path) => ({
    textTransform: "none",
    color: isActive(path) ? "#006D77" : "#121212",
    fontWeight: isActive(path) ? "bold" : "bold",
    borderBottom: isActive(path) ? "2px solid #006D77" : "2px solid transparent",
    borderRadius: 0,
    fontSize: navFontSize,
    whiteSpace: "nowrap",
    minWidth: "auto",
    px: navPx,
    transition: "all 0.18s",
    "&:hover": { color: "#006D77", backgroundColor: "transparent", borderBottom: "2px solid #006D77" },
  });

  // ─── Drawer (mobile) ──────────────────────────────────────────────────────
  const renderDrawer = () => (
    <Drawer
      anchor="right"
      open={drawerOpen}
      onClose={() => setDrawerOpen(false)}
      PaperProps={{
        sx: {
          width: 280,
          backgroundColor: "#f9fafb",
          borderTopLeftRadius: 16,
          borderBottomLeftRadius: 16,
        },
      }}
    >
      {/* Drawer header */}
      <Box sx={{
        background: "linear-gradient(135deg, #006D77 0%, #00838F 100%)",
        px: 2.5, pt: 3, pb: 2.5,
        display: "flex", alignItems: "center", justifyContent: "space-between",
      }}>
        {user ? (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <Avatar
              alt={user.name}
              src={user.avatarUrl || ""}
              sx={{ width: 42, height: 42, bgcolor: "rgba(255,255,255,0.25)", fontWeight: "bold", fontSize: 18, border: "2px solid rgba(255,255,255,0.5)" }}
            >
              {!user.avatarUrl && user.name ? user.name.charAt(0).toUpperCase() : ""}
            </Avatar>
            <Box>
              <Typography sx={{ fontWeight: 700, color: "#fff", fontSize: 15 }}>{user.name}</Typography>
              <Typography sx={{ fontSize: 11, color: "rgba(255,255,255,0.7)", textTransform: "capitalize" }}>
                {user.role}
              </Typography>
            </Box>
          </Box>
        ) : (
          <Typography sx={{ fontWeight: 700, color: "#fff", fontSize: 16 }}>Menu</Typography>
        )}
        <IconButton onClick={() => setDrawerOpen(false)} sx={{ color: "#fff" }}>
          <CloseIcon />
        </IconButton>
      </Box>

      <List sx={{ pt: 1, pb: 2 }}>
        {/* Public links */}
        {!user && publicNavLinks.map((link) => (
          <ListItem key={link.path} disablePadding>
            <ListItemButton
              onClick={() => { navigate(link.path); setDrawerOpen(false); }}
              selected={isActive(link.path)}
              sx={{
                mx: 1, borderRadius: 2, mb: 0.5,
                "&.Mui-selected": { backgroundColor: "#E0F7FA", color: "#006D77" },
              }}
            >
              <ListItemText
                primary={link.label}
                primaryTypographyProps={{ fontWeight: isActive(link.path) ? 700 : 500, fontSize: 14 }}
              />
            </ListItemButton>
          </ListItem>
        ))}

        {/* Logged-in: base links */}
        {user && baseUserLinks.map((link) => (
          <ListItem key={link.path} disablePadding>
            <ListItemButton
              onClick={() => { navigate(link.path); setDrawerOpen(false); }}
              selected={isActive(link.path)}
              sx={{
                mx: 1, borderRadius: 2, mb: 0.5,
                "&.Mui-selected": { backgroundColor: "#E0F7FA", color: "#006D77" },
              }}
            >
              <ListItemText
                primary={link.label}
                primaryTypographyProps={{ fontWeight: isActive(link.path) ? 700 : 500, fontSize: 14 }}
              />
            </ListItemButton>
          </ListItem>
        ))}

        {/* ORDERS accordion — resident only */}
        {user?.role === "resident" && (
          <>
            <ListItem disablePadding>
              <ListItemButton
                onClick={() => setOrdersDrawerOpen((v) => !v)}
                sx={{
                  mx: 1, borderRadius: 2, mb: 0.5,
                  backgroundColor: isOrderActive ? "#E0F7FA" : ordersDrawerOpen ? "#F0FFFE" : "transparent",
                  "&:hover": { backgroundColor: "#E0F7FA" },
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, flex: 1 }}>
                  <ShoppingBagOutlinedIcon sx={{ fontSize: 18, color: isOrderActive || ordersDrawerOpen ? "#006D77" : "#555" }} />
                  <ListItemText
                    primary="Orders"
                    primaryTypographyProps={{
                      fontWeight: 700, fontSize: 14,
                      color: isOrderActive || ordersDrawerOpen ? "#006D77" : "#1a1a1a",
                    }}
                  />
                </Box>
                {ordersDrawerOpen
                  ? <KeyboardArrowUpIcon sx={{ color: "#006D77", fontSize: 18 }} />
                  : <KeyboardArrowDownIcon sx={{ color: "#888", fontSize: 18 }} />
                }
              </ListItemButton>
            </ListItem>

            <Collapse in={ordersDrawerOpen} timeout={200}>
              <Box sx={{ mx: 1, mb: 0.5 }}>
                {orderSubLinks.map((item) => (
                  <ListItemButton
                    key={item.path}
                    onClick={() => { navigate(item.path); setDrawerOpen(false); setOrdersDrawerOpen(false); }}
                    selected={isActive(item.path)}
                    sx={{
                      borderRadius: "10px", mb: 0.5, pl: 2,
                      "&.Mui-selected": { backgroundColor: item.bg },
                      "&:hover": { backgroundColor: item.bg },
                    }}
                  >
                    <Box sx={{
                      width: 30, height: 30, borderRadius: "8px", mr: 1.5, flexShrink: 0,
                      backgroundColor: item.bg, color: item.color,
                      display: "flex", alignItems: "center", justifyContent: "center",
                    }}>
                      {React.cloneElement(item.icon, { sx: { fontSize: 16 } })}
                    </Box>
                    <ListItemText
                      primary={item.label}
                      secondary={item.desc}
                      primaryTypographyProps={{
                        fontWeight: isActive(item.path) ? 700 : 600, fontSize: 13,
                        color: isActive(item.path) ? item.color : "#1a1a1a",
                      }}
                      secondaryTypographyProps={{ fontSize: 10.5, color: "#999" }}
                    />
                    {isActive(item.path) && (
                      <Box sx={{ width: 6, height: 6, borderRadius: "50%", backgroundColor: item.color, flexShrink: 0 }} />
                    )}
                  </ListItemButton>
                ))}
              </Box>
            </Collapse>

            <Divider sx={{ mx: 2, my: 1, borderColor: "#EEE" }} />

            {/* SUPPORT accordion — resident only */}
            <ListItem disablePadding>
              <ListItemButton
                onClick={() => setSupportDrawerOpen((v) => !v)}
                sx={{
                  mx: 1, borderRadius: 2, mb: 0.5,
                  backgroundColor: isSupportActive ? "#FFEBEE" : supportDrawerOpen ? "#FFF5F5" : "transparent",
                  "&:hover": { backgroundColor: "#FFEBEE" },
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, flex: 1 }}>
                  <ForumOutlinedIcon sx={{ fontSize: 18, color: isSupportActive || supportDrawerOpen ? "#C62828" : "#555" }} />
                  <ListItemText
                    primary="Complaints & Feedback"
                    primaryTypographyProps={{
                      fontWeight: 700, fontSize: 14,
                      color: isSupportActive || supportDrawerOpen ? "#C62828" : "#1a1a1a",
                    }}
                  />
                </Box>
                {supportDrawerOpen
                  ? <KeyboardArrowUpIcon sx={{ color: "#C62828", fontSize: 18 }} />
                  : <KeyboardArrowDownIcon sx={{ color: "#888", fontSize: 18 }} />
                }
              </ListItemButton>
            </ListItem>

            <Collapse in={supportDrawerOpen} timeout={200}>
              <Box sx={{ mx: 1, mb: 0.5 }}>
                {supportSubLinks.map((item) => (
                  <ListItemButton
                    key={item.path}
                    onClick={() => { navigate(item.path); setDrawerOpen(false); setSupportDrawerOpen(false); }}
                    selected={isActive(item.path)}
                    sx={{
                      borderRadius: "10px", mb: 0.5, pl: 2,
                      "&.Mui-selected": { backgroundColor: item.bg },
                      "&:hover": { backgroundColor: item.bg },
                    }}
                  >
                    <Box sx={{
                      width: 30, height: 30, borderRadius: "8px", mr: 1.5, flexShrink: 0,
                      backgroundColor: item.bg, color: item.color,
                      display: "flex", alignItems: "center", justifyContent: "center",
                    }}>
                      {React.cloneElement(item.icon, { sx: { fontSize: 16 } })}
                    </Box>
                    <ListItemText
                      primary={item.label}
                      secondary={item.desc}
                      primaryTypographyProps={{
                        fontWeight: isActive(item.path) ? 700 : 600, fontSize: 13,
                        color: isActive(item.path) ? item.color : "#1a1a1a",
                      }}
                      secondaryTypographyProps={{ fontSize: 10.5, color: "#999" }}
                    />
                    {isActive(item.path) && (
                      <Box sx={{ width: 6, height: 6, borderRadius: "50%", backgroundColor: item.color, flexShrink: 0 }} />
                    )}
                  </ListItemButton>
                ))}
              </Box>
            </Collapse>

            <Divider sx={{ mx: 2, my: 1, borderColor: "#EEE" }} />

            {extraResidentLinks.map((link) => (
              <ListItem key={link.path} disablePadding>
                <ListItemButton
                  onClick={() => { navigate(link.path); setDrawerOpen(false); }}
                  selected={isActive(link.path)}
                  sx={{
                    mx: 1, borderRadius: 2, mb: 0.5,
                    "&.Mui-selected": { backgroundColor: "#E0F7FA", color: "#006D77" },
                  }}
                >
                  <ListItemText
                    primary={link.label}
                    primaryTypographyProps={{ fontWeight: isActive(link.path) ? 700 : 500, fontSize: 14 }}
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </>
        )}

        {/* Login / Register (guest) */}
        {!user && (
          <>
            <Divider sx={{ mx: 2, my: 1 }} />
            {[{ label: "Login", path: "/Login" }, { label: "Register", path: "/Register" }].map((l) => (
              <ListItem key={l.path} disablePadding>
                <ListItemButton onClick={() => { navigate(l.path); setDrawerOpen(false); }} sx={{ mx: 1, borderRadius: 2 }}>
                  <ListItemText primary={l.label} primaryTypographyProps={{ fontWeight: 700, fontSize: 14 }} />
                </ListItemButton>
              </ListItem>
            ))}
          </>
        )}
      </List>
    </Drawer>
  );

  // ─── Desktop nav links for resident ───────────────────────────────────────
  const desktopResidentLinks = [
    ...baseUserLinks,
    ...extraResidentLinks,
  ];

  return (
    <AppBar position="fixed" sx={{ backgroundColor: "#fff", color: "#153f4b", boxShadow: "0 2px 12px rgba(0,0,0,0.07)", zIndex: 13000 }}>
      <Toolbar sx={{ flexDirection: "column", padding: "0!important" }}>

        {/* ── NOT LOGGED IN ─────────────────────────────────────────────── */}
        {!user && (
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", px: { xs: 2, sm: 3, md: 4, lg: 6 }, py: 1 }}>
            <Box display="flex" alignItems="center" sx={{ flexShrink: 0 }}>
              <img src={ayujalogo} alt="Ayuja Logo" style={{ width: isMobile ? 110 : 150, height: isMobile ? 36 : 48, marginRight: 10 }} />
            </Box>
            {!isMobile && (
              <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: isTablet ? 1 : 3, flexGrow: 1 }}>
                {publicNavLinks.map((link) => (
                  <Button key={link.path} onClick={() => navigate(link.path)} sx={navBtnSx(link.path)}>
                    {link.label}
                  </Button>
                ))}
              </Box>
            )}
            {!isMobile && (
              <Box sx={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
                <ToggleButtonGroup value={selected} exclusive onChange={(_, v) => v && setSelected(v)}
                  sx={{ width: isTablet ? "130px" : "150px", height: "35px", borderRadius: "30px", overflow: "hidden", border: "1px solid teal" }}>
                  <ToggleButton value="login" onClick={() => navigate("/Login")}
                    sx={{ textTransform: "none", fontWeight: "bold", fontSize: isTablet ? "12px" : "14px", px: isTablet ? 1.5 : 2, "&.Mui-selected": { background: "linear-gradient(to right, seagreen, #22577A)", color: "white" } }}>
                    Login
                  </ToggleButton>
                  <ToggleButton value="register" onClick={() => navigate("/Register")}
                    sx={{ textTransform: "none", fontWeight: "bold", fontSize: isTablet ? "12px" : "14px", "&.Mui-selected": { background: "linear-gradient(to right, seagreen, #22577A)", color: "white" } }}>
                    Register
                  </ToggleButton>
                </ToggleButtonGroup>
              </Box>
            )}
            {isMobile && (
              <IconButton onClick={() => setDrawerOpen(true)} sx={{ color: "#153f4b" }}>
                <MenuIcon />
              </IconButton>
            )}
          </Box>
        )}

        {/* ── LOGGED IN ─────────────────────────────────────────────────── */}
        {user && (
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", backgroundColor: "white", px: { xs: 2, sm: 3, md: 4, lg: 6 }, py: 1, gap: 1 }}>
            {/* Logo */}
            <Box display="flex" alignItems="center" sx={{ flexShrink: 0 }}>
              <img src={ayujalogo} alt="Ayuja Logo" style={{ width: isMobile ? 110 : 150, height: isMobile ? 36 : 48 }} />
            </Box>

            {/* Desktop nav */}
            {!isMobile && (
              <Box sx={{ display: "flex", alignItems: "center", gap: isTablet ? 0.5 : 1.5, flexGrow: 1, justifyContent: "center", overflow: "visible" }}>
                {/* Base links */}
                {baseUserLinks.map((link) => (
                  <Button key={link.path} onClick={() => navigate(link.path)} sx={navBtnSx(link.path)}>
                    {link.label}
                  </Button>
                ))}

                {/* Orders dropdown — resident only */}
                {user.role === "resident" && (
                  <OrdersDropdown
                    navFontSize={navFontSize}
                    navPx={navPx}
                    isActive={isActive}
                    navigate={navigate}
                    location={location}
                  />
                )}

                {/* Complaints & Feedback dropdown — resident only */}
                {user.role === "resident" && (
                  <SupportDropdown
                    navFontSize={navFontSize}
                    navPx={navPx}
                    isActive={isActive}
                    navigate={navigate}
                    location={location}
                  />
                )}

                {/* Extra resident links */}
                {user.role === "resident" && extraResidentLinks.map((link) => (
                  <Button key={link.path} onClick={() => navigate(link.path)} sx={navBtnSx(link.path)}>
                    {link.label}
                  </Button>
                ))}
              <Button
                  onClick={confirmLogout}
                  sx={{
                    textTransform: "none",
                    color: "#D32F2F",
                    fontWeight: 600,
                    fontSize: navFontSize,
                    px: navPx,
                    "&:hover": {
                      backgroundColor: "#fdecea",
                    },
                  }}
                >
                  Logout
              </Button>
              </Box>
            )}

            {/* Right: avatar + name */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexShrink: 0 }}>
              {!isMobile && (
                <Typography variant="body1" sx={{ color: "black", fontWeight: "bold", fontSize: isTablet ? "13px" : "15px" }}>
                  {user.name}
                </Typography>
              )}
              <Avatar
                alt={user.name}
                src={user.avatarUrl || ""}
                sx={{ width: 38, height: 38, bgcolor: "#007a85", fontWeight: "bold", fontSize: "16px" }}
              >
                {!user.avatarUrl && user.name ? user.name.charAt(0).toUpperCase() : ""}
              </Avatar>
              {isMobile && (
                <IconButton onClick={() => setDrawerOpen(true)} sx={{ color: "#153f4b" }}>
                  <MenuIcon />
                </IconButton>
              )}
            </Box>
          </Box>
        )}
      </Toolbar>

      {renderDrawer()}

      <CustomDialog
        open={dialogOpen}
        title="Confirm Logout"
        message="Are you sure you want to log out?"
        onClose={() => setDialogOpen(false)}
        buttonText="Yes"
        secondaryButtonText="Cancel"
        onPrimaryAction={() => { setDialogOpen(false); handleLogout(); }}
        onSecondaryAction={() => setDialogOpen(false)}
        type="warning"
      />
    </AppBar>
  );
}

export default Header;